import { env } from "@/env.mjs";


export function getMedia(location: string) {
    return `${env.NEXT_PUBLIC_CLOUDFRONT_URL}/public/${(location.includes(" ")) ? encodeURIComponent(location) : location}`;
}
